"use client";

import { ArrowRight, Check, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const trustItems = [{
    id: 1,
    label: "Precision engineering"
  }, {
    id: 2,
    label: "Quality assurance"
  }, {
    id: 3,
    label: "Certified standards"
  }];
  return <section data-section-id="773" id="call-to-action" className="bg-background text-foreground relative overflow-hidden">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -top-32 -left-32 h-96 w-96 rounded-lg opacity-30 blur-3xl" style={{
      background: "var(--primary)"
    }} />
      <div aria-hidden="true" className="pointer-events-none absolute -bottom-40 -right-32 h-[28rem] w-[28rem] rounded-lg opacity-30 blur-3xl" style={{
      background: "var(--primary)"
    }} />

      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0">
        <div className="absolute top-[12%] left-[8%] text-2xl opacity-40" style={{
        color: "var(--primary)"
      }}>
          
        </div>
        <div className="absolute top-[22%] right-[14%] text-xl opacity-40" style={{
        color: "var(--primary)"
      }}>
          
        </div>
        <div className="absolute bottom-[18%] left-[16%] text-lg opacity-40" style={{
        color: "var(--primary)"
      }}>
          
        </div>
        <div className="absolute bottom-[28%] right-[10%] text-2xl opacity-40" style={{
        color: "var(--primary)"
      }}>
          
        </div>
        <div className="absolute top-[45%] left-[5%] text-base opacity-30" style={{
        color: "var(--primary)"
      }}>
          
        </div>
        <div className="absolute top-[55%] right-[6%] text-base opacity-30" style={{
        color: "var(--primary)"
      }}>
          
        </div>
      </div>

      <div ref={ref} className={`relative mx-auto max-w-[900px] px-6 py-24 md:py-32 lg:py-[140px] text-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {}
        <p className="font-default text-xs sm:text-sm font-semibold tracking-[0.25em] uppercase mb-8 text-primary">
          Ready for Excellence
        </p>

        {}
        <h2 className="font-default font-normal leading-[1.05] tracking-tight text-[clamp(2.75rem,7vw,6rem)] mb-8 text-foreground">
          Your{" "}
          <span className="relative inline-block">
            <span>industrial</span>
            <svg aria-hidden="true" className="absolute left-0 right-0 -bottom-2 sm:-bottom-3 w-full" viewBox="0 0 200 14" preserveAspectRatio="none" fill="none">
              <path d="M2 8 Q 25 2, 50 7 T 100 7 T 150 7 T 198 6" stroke="var(--primary)" strokeWidth="3" strokeLinecap="round" fill="none" />
            </svg>
          </span>{" "}
          solution starts here.
        </h2>

        {}
        <p className="font-default mx-auto max-w-[560px] text-base sm:text-lg leading-relaxed mb-10 text-muted-foreground">Partner with industry leaders in phenolic engraving. Advanced materials, rigorous testing, and reliable supply chains — no compromises, just high-performance results for your projects.</p>

        {}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-5 sm:gap-8 mb-10">
          <Button asChild size="lg" className="group rounded-lg px-10 py-6 text-base h-auto shadow-md hover:shadow-lg transition-shadow bg-primary text-primary-foreground">
            <Link to="/ContactPage">
              <span>Request Consultation</span>
              <ArrowRight className="ml-1 size-5 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Button>

          
        </div>

        {}
        <div className="font-default flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs sm:text-sm font-medium text-muted-foreground">
          {trustItems.map((item, i) => <div data-index={i} key={item.id} className="inline-flex items-center gap-1.5">
              <Check className="size-4 text-primary" strokeWidth={2.5} />
              <span>{item.label}</span>
              {i < trustItems.length - 1 && <span className="ml-3 opacity-50" aria-hidden="true">
                  ·
                </span>}
            </div>)}
        </div>
      </div>
    </section>;
}